export const transformMeasureUnit = (measure: string) => {
  const measureConversionObj = {
    TO: 'T',
    ST: 'PC',
    ZBA: 'BR',
    RL: 'ROL',
    KI: 'CX'
  } as Record<string, string>;
  if (measure in measureConversionObj) {
    return measureConversionObj[measure];
  }
  return measure;
};
